module.exports = "<div class=\"dpsModule\">\n  <dashboard-dps></dashboard-dps>\n</div>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dataprotection/dataprotection-vcd/dataprotection-vcd.html
// module id = xEBg
// module chunks = 0